var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#515151"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2155 6.45227L7.99832 8.66941L5.78118 6.45227C5.72827 6.39937 5.66547 6.3574 5.59634 6.32877C5.52722 6.30014 5.45314 6.2854 5.37832 6.2854C5.3035 6.2854 5.22942 6.30014 5.1603 6.32877C5.09117 6.3574 5.02837 6.39937 4.97546 6.45227C4.92256 6.50517 4.88059 6.56798 4.85196 6.6371C4.82333 6.70622 4.80859 6.78031 4.80859 6.85513C4.80859 6.92994 4.82333 7.00403 4.85196 7.07315C4.88059 7.14227 4.92256 7.20508 4.97546 7.25798L7.59832 9.88084C7.82118 10.1037 8.18118 10.1037 8.40403 9.88084L11.0269 7.25798C11.0799 7.20512 11.1219 7.14233 11.1506 7.0732C11.1792 7.00407 11.194 6.92997 11.194 6.85513C11.194 6.78029 11.1792 6.70618 11.1506 6.63706C11.1219 6.56793 11.0799 6.50513 11.0269 6.45227C10.804 6.23513 10.4383 6.22941 10.2155 6.45227Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.6fe2c9177f88d4ceeadf1d55a709bc5c.svg";
export { ForwardRef as ReactComponent };